module.exports = __webpack_public_path__ + "static/media/fa-light-300.1420ebcb.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-light-300.woff
// module id = 734
// module chunks = 0